/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Zpoždění`
};

const da_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Forsinket`
};

const de_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Verspätet`
};

const en_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Late`
};

const es_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Retraso`
};

const fr_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Retard`
};

const hu_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Késedelem`
};

const it_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `In ritardo`
};

const nl_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Vertraagd`
};

const pl_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Opóźnienie`
};

const pt_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Atrasado`
};

const sv_order_statuses_complete_late = /** @type {(inputs: {}) => string} */ () => {
	return `Försenad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_complete_late = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_complete_late(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_complete_late", locale)
	if (locale === "cs") return cs_order_statuses_complete_late(inputs)
	if (locale === "da") return da_order_statuses_complete_late(inputs)
	if (locale === "de") return de_order_statuses_complete_late(inputs)
	if (locale === "en") return en_order_statuses_complete_late(inputs)
	if (locale === "es") return es_order_statuses_complete_late(inputs)
	if (locale === "fr") return fr_order_statuses_complete_late(inputs)
	if (locale === "hu") return hu_order_statuses_complete_late(inputs)
	if (locale === "it") return it_order_statuses_complete_late(inputs)
	if (locale === "nl") return nl_order_statuses_complete_late(inputs)
	if (locale === "pl") return pl_order_statuses_complete_late(inputs)
	if (locale === "pt") return pt_order_statuses_complete_late(inputs)
	return sv_order_statuses_complete_late(inputs)
};
export { order_statuses_complete_late as "order_statuses.complete_late" }